import { Component, Input, OnInit } from "@angular/core";
import {
    trigger,
    state,
    style,
    transition,
    animate,
} from "@angular/animations";
import { MenuItem } from "primeng/api";
import { SecureComponent } from "./secure/secure.component";
import { AuthService } from "common/services/auth.service";

@Component({
    selector: "app-menu",
    template: `
        <ul
            app-submenu
            [item]="model"
            root="true"
            class="ultima-menu ultima-main-menu clearfix"
            [reset]="reset"
            visible="true"
            parentActive="true"
        ></ul>
        <app-footer></app-footer>
    `,
})
export class AppMenuComponent implements OnInit {
    @Input() reset = false;

    model: any[] = [];
    checkArray = false;
    user: any;
    constructor(public app: SecureComponent) { }

    ngOnInit() {
        this.initMenu();
    }
    // this.model = [
    //     { label: 'Dashboard', icon: 'dashboard', routerLink: ['/dashboard'] },
    //     { label: 'Member Management', icon: 'group', routerLink: ['/members'] },
    //     { label: 'Visitor Management', icon: 'content_paste', routerLink: ['/visitors'] },
    //     { label: 'Account Management', icon: 'content_copy', routerLink: ['/accounts'] },
    //     { label: 'Attendance', icon: 'hourglass_empty', routerLink: ['/attendance'] },
    //     { label: 'Reports', icon: 'content_copy', routerLink: ['/reports'] },
    //     {
    //         label: 'Settings', icon: 'settings_application',
    //         items: [
    //             { label: 'User Management', icon: 'group', routerLink: ['/settings'] },
    //             { label: 'Role Management', icon: 'verified_user', routerLink: ['/settings/roles'] },
    //             { label: 'Permission Management', icon: 'security', routerLink: ['/settings/permissions'] },
    //             { label: 'Branch Management', icon: 'store-mall-directory', routerLink: ['/settings/branches'] },
    //             { label: 'Company Management', icon: 'build', routerLink: ['/settings/companies'] },
    //             {
    //                 label: 'App Customization', icon: 'settings_application',
    //                 items: [
    //                     { label: 'Static Menu', icon: 'menu', command: () => this.app.changeToStaticMenu() },
    //                     { label: 'Horizontal Menu', icon: 'border_horizontal', command: () => this.app.changeToHorizontalMenu() },
    //                     { label: 'Light Menu', icon: 'label_outline', command: () => this.app.darkMenu = false },
    //                     { label: 'Dark Menu', icon: 'label', command: () => this.app.darkMenu = true }
    //                 ]
    //             }
    //         ]
    //     },
    //     {
    //         label: 'Themes', icon: 'palette', badge: '6',
    //         items: [
    //             { label: 'Indigo - Pink', icon: 'brush', command: (event) => { this.changeTheme('indigo'); } },
    //             { label: 'Brown - Green', icon: 'brush', command: (event) => { this.changeTheme('brown'); } },
    //             { label: 'Blue - Amber', icon: 'brush', command: (event) => { this.changeTheme('blue'); } },
    //             { label: 'Blue Grey - Green', icon: 'brush', command: (event) => { this.changeTheme('blue-grey'); } },
    //             { label: 'Dark - Blue', icon: 'brush', command: (event) => { this.changeTheme('dark-blue'); } },
    //             { label: 'Dark - Green', icon: 'brush', command: (event) => { this.changeTheme('dark-green'); } },
    //             { label: 'Green - Yellow', icon: 'brush', command: (event) => { this.changeTheme('green'); } },
    //             { label: 'Purple - Cyan', icon: 'brush', command: (event) => { this.changeTheme('purple-cyan'); } },
    //             { label: 'Purple - Amber', icon: 'brush', command: (event) => { this.changeTheme('purple-amber'); } },
    //             { label: 'Teal - Lime', icon: 'brush', command: (event) => { this.changeTheme('teal'); } },
    //             { label: 'Cyan - Amber', icon: 'brush', command: (event) => { this.changeTheme('cyan'); } },
    //             { label: 'Grey - Deep Orange', icon: 'brush', command: (event) => { this.changeTheme('grey'); } }
    //         ]
    //     },
    //     {
    //         label: 'Components', icon: 'list', badge: '2', badgeStyleClass: 'teal-badge',
    //         items: [
    //             { label: 'Sample Page', icon: 'desktop_mac', routerLink: ['/sample'] },
    //             { label: 'Forms', icon: 'input', routerLink: ['/forms'] },
    //             { label: 'Data', icon: 'grid_on', routerLink: ['/data'] },
    //             { label: 'Panels', icon: 'content_paste', routerLink: ['/panels'] },
    //             { label: 'Overlays', icon: 'content_copy', routerLink: ['/overlays'] },
    //             { label: 'Menus', icon: 'menu', routerLink: ['/menus'] },
    //             { label: 'Messages', icon: 'message', routerLink: ['/messages'] },
    //             { label: 'Charts', icon: 'insert_chart', routerLink: ['/charts'] },
    //             { label: 'File', icon: 'attach_file', routerLink: ['/file'] },
    //             { label: 'Misc', icon: 'toys', routerLink: ['/misc'] }
    //         ]
    //     },
    //     {
    //         label: 'Template Pages', icon: 'get_app',
    //         items: [
    //             { label: 'Empty Page', icon: 'hourglass_empty', routerLink: ['/empty'] },
    //             { label: 'Landing Page', icon: 'flight_land', url: 'assets/pages/landing.html', target: '_blank' },
    //             { label: 'Login Page', icon: 'verified_user', routerLink: ['/login'], target: '_blank' },
    //             { label: 'Error Page', icon: 'error', routerLink: ['/error'], target: '_blank' },
    //             { label: '404 Page', icon: 'error_outline', routerLink: ['/404'], target: '_blank' },
    //             { label: 'Access Denied Page', icon: 'security', routerLink: ['/accessdenied'], target: '_blank' }
    //         ]
    //     },
    //     {
    //         label: 'Menu Hierarchy', icon: 'menu',
    //         items: [
    //             {
    //                 label: 'Submenu 1', icon: 'subject',
    //                 items: [
    //                     {
    //                         label: 'Submenu 1.1', icon: 'subject',
    //                         items: [
    //                             { label: 'Submenu 1.1.1', icon: 'subject' },
    //                             { label: 'Submenu 1.1.2', icon: 'subject' },
    //                             { label: 'Submenu 1.1.3', icon: 'subject' },
    //                         ]
    //                     },
    //                     {
    //                         label: 'Submenu 1.2', icon: 'subject',
    //                         items: [
    //                             { label: 'Submenu 1.2.1', icon: 'subject' },
    //                             { label: 'Submenu 1.2.2', icon: 'subject' }
    //                         ]
    //                     },
    //                 ]
    //             },
    //             {
    //                 label: 'Submenu 2', icon: 'subject',
    //                 items: [
    //                     {
    //                         label: 'Submenu 2.1', icon: 'subject',
    //                         items: [
    //                             { label: 'Submenu 2.1.1', icon: 'subject' },
    //                             { label: 'Submenu 2.1.2', icon: 'subject' },
    //                             { label: 'Submenu 2.1.3', icon: 'subject' },
    //                         ]
    //                     },
    //                     {
    //                         label: 'Submenu 2.2', icon: 'subject',
    //                         items: [
    //                             { label: 'Submenu 2.2.1', icon: 'subject' },
    //                             { label: 'Submenu 2.2.2', icon: 'subject' }
    //                         ]
    //                     },
    //                 ]
    //             }
    //         ]
    //     },
    //     { label: 'Utils', icon: 'build', routerLink: ['/utils'] },
    //     { label: 'Documentation', icon: 'find_in_page', routerLink: ['/documentation'] }
    // ];

    initMenu() {
        const roleJson = localStorage.getItem("currentRole");
        if (!roleJson) {
            return;
        }
        const role = JSON.parse(roleJson);
        this.model = [];
        if (role.privileges !== null && role.privileges.length > 0) {
            const seenPrivilegeKeys = new Set<string>();
            const privileges = role.privileges.filter((permission: any) => {
                const key = `${permission?.pageType ?? ""}|${permission?.pageName ?? ""}`;
                if (seenPrivilegeKeys.has(key)) {
                    return false;
                }
                seenPrivilegeKeys.add(key);
                return true;
            });
            privileges.forEach((permission: any) => {

                if (permission.pageType === "Dashboard") {
                    this.model.push({
                        label: "Dashboard",
                        icon: "dashboard",
                        routerLink: ["/dashboard"],
                    });
                }
                if (permission.pageType === "Member Management") {
                    this.model.push({
                        label: "Member Management",
                        icon: "group",
                        routerLink: ["/members"],
                    });
                }
                if (permission.pageType === "Activity Logs") {
                    this.model.push({
                        label: "Activity Logs",
                        icon: "group",
                        routerLink: ["/activity-logs"],
                    });
                }

                if (permission.pageType === "Inactive Members") {
                    this.model.push({
                        label: "Inactive Members",
                        icon: "group",
                        routerLink: ["/members/inactive"],
                    });
                }
                // if (permission.pageType === "Trainer Management") {
                //     this.model.push({
                //         label: "Trainer Management",
                //         icon: "group",
                //         routerLink: ["/trainers"],
                //     });
                // }
                if (permission.pageType === "Notifications Management" &&
                    permission.pageName === "Notifications") {
                    this.model.push({
                        label: "Notification Management",
                        icon: "group",
                        routerLink: ["/notifications"],
                    });
                }
                if (permission.pageType === "Enquiry Management") {
                    this.model.push({
                        label: "Enquiry Management",
                        icon: "group",
                        routerLink: ["/enquiry-listing"],
                    });
                }
                if (permission.pageType === "Visitors Management") {
                    this.model.push({
                        label: "Visitor Management",
                        icon: "content_paste",
                        routerLink: ["/visitors"],
                    });
                }
                if (permission.pageType === "Requests Management") {
                    this.model.push({
                        label: "Request Management",
                        icon: "group",
                        routerLink: ["/requests-management"],
                    });
                }
                if (permission.pageType === "Member Requests") {
                    this.model.push({
                        label: "Member requests",
                        icon: "group",
                        routerLink: ["/member-requests"],
                    });
                }
                if (permission.pageType === "Fees Approval") {
                    this.model.push({
                        label: "Fees Approval",
                        icon: "group",
                        routerLink: ["/feesApproval"],
                    });
                }
                if (permission.pageType === "Asset Management") {
                    this.model.push({
                        label: "Asset Management",
                        icon: "group",
                        routerLink: ["/assets-management"],
                    });
                }
                if (permission.pageType === "Account Management") {
                    this.model.push({
                        label: "Account Management",
                        icon: "content_copy",
                        routerLink: ["/accounts"],
                    });
                }
                if (permission.pageType === "Attendance") {
                    this.model.push({
                        label: "Attendance",
                        icon: "hourglass_empty",
                        routerLink: ["/attendance"],
                    });
                }
                if (permission.pageType === "Package Builder") {
                    this.model.push({
                        label: "Package Builder",
                        icon: "group",
                        routerLink: ["/package-Builders"],
                    });
                }

                // SLOTS MANAGEMENT IS HERE
                if (
                    permission.pageType === "Slots Management" &&
                    permission.pageName === "Bookings"
                ) {
                    const check = this.model.filter(
                        (x) => x.label === "Slot Management"
                    );
                    const index = this.model.indexOf(check[0]);
                    if (check.length > 0) {
                        this.model[index].items.push({
                            label: "Bookings",
                            icon: "content_copy",
                            routerLink: ["/bookings"],
                        });
                    } else {
                        this.model.push({
                            label: "Slot Management",
                            icon: "settings_application",
                            items: [
                                {
                                    label: "Bookings",
                                    icon: "settings_application",
                                    routerLink: ["/bookings"],
                                },
                            ],
                        });
                    }
                }

                if (
                    permission.pageType === "Slots Management" &&
                    permission.pageName === "Booking Slots"
                ) {
                    const check = this.model.filter(
                        (x) => x.label === "Slot Management"
                    );
                    const index = this.model.indexOf(check[0]);
                    if (check.length > 0) {
                        this.model[index].items.push({
                            label: "Slots",
                            icon: "settings_application",
                            routerLink: ["/slots"],
                        });
                    } else {
                        this.model.push({
                            label: "Slot Management",
                            icon: "settings_application",
                            items: [
                                {
                                    label: "Slots",
                                    icon: "content_copy",
                                    routerLink: ["/slots"],
                                },
                            ],
                        });
                    }
                }
                if (
                    permission.pageType === "Reports" &&
                    permission.pageName === "In-Active Member Report"
                ) {
                    const check = this.model.filter(
                        (x) => x.label === "Reports"
                    );
                    const index = this.model.indexOf(check[0]);
                    if (check.length > 0) {
                        this.model[index].items.push({
                            label: "Inactive Member Report",
                            icon: "hourglass_empty",
                            routerLink: ["/reports/In-Active Member Report"],
                        });
                    } else {
                        this.model.push({
                            label: "Reports",
                            icon: "insert_chart",
                            items: [
                                {
                                    label: "Inactive Member Report",
                                    icon: "hourglass_empty",
                                    routerLink: ["/reports/In-Active Member Report"],
                                },
                            ],
                        });
                    }
                }

                // if (
                //     permission.pageType === "Reports" &&
                //     permission.pageName === "Billing Report"
                // ) {
                //     const check = this.model.filter(
                //         (x) => x.label === "Reports"
                //     );
                //     const index = this.model.indexOf(check[0]);
                //     if (check.length > 0) {
                //         this.model[index].items.push({
                //             label: "Billing Report",
                //             icon: "content_copy",
                //             routerLink: ["/reports"],
                //         });
                //     } else {
                //         this.model.push({
                //             label: "Reports",
                //             icon: "insert_chart",
                //             items: [
                //                 {
                //                     label: "Billing Report",
                //                     icon: "content_copy",
                //                     routerLink: ["/reports"],
                //                 },
                //             ],
                //         });
                //     }
                // }
                if (
                    permission.pageType === "Reports" &&
                    permission.pageName === "Billing"
                ) {
                    const check = this.model.filter(
                        (x) => x.label === "Reports"
                    );
                    const index = this.model.indexOf(check[0]);
                    if (check.length > 0) {
                        this.model[index].items.push({
                            label: "Billing",
                            icon: "content_copy",
                            routerLink: ["/reports/billing"],
                        });
                    } else {
                        this.model.push({
                            label: "Reports",
                            icon: "insert_chart",
                            items: [
                                {
                                    label: "Billing",
                                    icon: "content_copy",
                                    routerLink: ["/reports/billing"],
                                },
                            ],
                        });
                    }
                }
                       if (
                    permission.pageType === "Reports" &&
                    permission.pageName === "Daily Sales"
                ) {
                    const check = this.model.filter(
                        (x) => x.label === "Reports"
                    );
                    const index = this.model.indexOf(check[0]);
                    if (check.length > 0) {
                        this.model[index].items.push({
                            label: "Daily Sales",
                            icon: "content_copy",
                            routerLink: ["/reports/dailySalesReport"],
                        });
                    } else {
                        this.model.push({
                            label: "Reports",
                            icon: "insert_chart",
                            items: [
                                {
                                    label: "Daily Sales",
                                    icon: "content_copy",
                                    routerLink: ["/reports/dailySalesReport"],
                                },
                            ],
                        });
                    }
                }
                if (
                    permission.pageType === "Reports" &&
                    (permission.pageName === "Trainer Clients" ||
                        permission.pageName === "Sale Reports")
                ) {
                    const check = this.model.filter(
                        (x) => x.label === "Reports"
                    );
                    const trainerClientsItem = {
                        label: "Trainer Clients",
                        icon: "content_copy",
                        routerLink: ["/reports/trainer-clients"],
                    };
                    if (check.length > 0) {
                        const index = this.model.indexOf(check[0]);
                        const already = (this.model[index].items || []).some(
                            (menuItem) => menuItem.label === "Trainer Clients"
                        );
                        if (!already) {
                            this.model[index].items.push(trainerClientsItem);
                        }
                    } else {
                        this.model.push({
                            label: "Reports",
                            icon: "insert_chart",
                            items: [trainerClientsItem],
                        });
                    }
                }
                if (
                    permission.pageType === "Reports" &&
                    permission.pageName === "Trainer Sales Report"
                ) {
                    const check = this.model.filter(
                        (x) => x.label === "Reports"
                    );
                    const index = this.model.indexOf(check[0]);
                    if (check.length > 0) {
                        this.model[index].items.push({
                            label: "Trainer Sales Report",
                            icon: "content_copy",
                            routerLink: ["/reports/trainer-sales-report"],
                        });
                    } else {
                        this.model.push({
                            label: "Reports",
                            icon: "insert_chart",
                            items: [
                                {
                                    label: "Trainer Sales Report",
                                    icon: "content_copy",
                                    routerLink: ["/reports/trainer-sales-report"],
                                },
                            ],
                        });
                    }
                }
                // if (
                //     permission.pageType === "Reports" &&
                //     permission.pageName === "Sales Report"
                // ) {
                //     const check = this.model.filter(
                //         (x) => x.label === "Reports"
                //     );
                //     const index = this.model.indexOf(check[0]);
                //     if (check.length > 0) {
                //         this.model[index].items.push({
                //             label: "Sales Report",
                //             icon: "content_copy",
                //             routerLink: ["reports/sales-report"],
                //         });
                //     } else {
                //         this.model.push({
                //             label: "Reports",
                //             icon: "insert_chart",
                //             items: [
                //                 {
                //                     label: "Sales Report",
                //                     icon: "content_copy",
                //                     routerLink: ["reports/sales-report"],
                //                 },
                //             ],
                //         });
                //     }
                // }
                if (
                    permission.pageType === "Reports" &&
                    permission.pageName === "Sales"
                ) {
                    const check = this.model.filter(
                        (x) => x.label === "Reports"
                    );
                    const index = this.model.indexOf(check[0]);
                    if (check.length > 0) {
                        this.model[index].items.push({
                            label: "Sales",
                            icon: "content_copy",
                            routerLink: ["reports/sales"],
                        });
                    } else {
                        this.model.push({
                            label: "Reports",
                            icon: "insert_chart",
                            items: [
                                {
                                    label: "Sales",
                                    icon: "content_copy",
                                    routerLink: ["reports/sales"],
                                },
                            ],
                        });
                    }
                }


                if (
                    permission.pageType === "Reports" &&
                    permission.pageName === "Absent Member Report"
                ) {
                    const check = this.model.filter(
                        (x) => x.label === "Reports"
                    );
                    const index = this.model.indexOf(check[0]);
                    if (check.length > 0) {
                        this.model[index].items.push({
                            label: "Absent Member Report",
                            icon: "content_copy",
                            routerLink: ["reports/absent-member-report"],
                        });
                    } else {
                        this.model.push({
                            label: "Reports",
                            icon: "insert_chart",
                            items: [
                                {
                                    label: "Absent Member Report",
                                    icon: "content_copy",
                                    routerLink: ["reports/absent-member-report"],
                                },
                            ],
                        });
                    }
                }


                if (
                    permission.pageType === "Reports" &&
                    permission.pageName === "Subscriptions Report"
                ) {
                    const check = this.model.filter(
                        (x) => x.label === "Reports"
                    );
                    const index = this.model.indexOf(check[0]);
                    if (check.length > 0) {
                        this.model[index].items.push({
                            label: "Subscriptions Report",
                            icon: "content_copy",
                            routerLink: ["reports/subscription-report"],
                        });
                    } else {
                        this.model.push({
                            label: "Reports",
                            icon: "insert_chart",
                            items: [
                                {
                                    label: "Subscriptions Report",
                                    icon: "content_copy",
                                    routerLink: ["reports/subscription-report"],
                                },
                            ],
                        });
                    }
                }
                if (
                    permission.pageType === "Reports" &&
                    permission.pageName === "Training Session Report"
                ) {
                    const check = this.model.filter(
                        (x) => x.label === "Reports"
                    );
                    const index = this.model.indexOf(check[0]);
                    if (check.length > 0) {
                        this.model[index].items.push({
                            label: "Training Session Report",
                            icon: "content_copy",
                            routerLink: ["reports/trainingServiceSession-report"],
                        });
                    } else {
                        this.model.push({
                            label: "Reports",
                            icon: "insert_chart",
                            items: [
                                {
                                    label: "Training Session Report",
                                    icon: "content_copy",
                                    routerLink: ["reports/trainingServiceSession-report"],
                                },
                            ],
                        });
                    }
                }
                if (
                    permission.pageType === "Reports" &&
                    permission.pageName === "Session Attendance Report"
                ) {
                    const check = this.model.filter(
                        (x) => x.label === "Reports"
                    );
                    const index = this.model.indexOf(check[0]);
                    if (check.length > 0) {
                        this.model[index].items.push({
                            label: "Session Attendance Report",
                            icon: "content_copy",
                            routerLink: ["reports/session-attendance-report"],
                        });
                    } else {
                        this.model.push({
                            label: "Reports",
                            icon: "insert_chart",
                            items: [
                                {
                                    label: "Session Attendance Report",
                                    icon: "content_copy",
                                    routerLink: ["reports/session-attendance-report"],
                                },
                            ],
                        });
                    }
                }
                if (
                    permission.pageType === "Reports" &&
                    permission.pageName === "Session Sales Report"
                ) {
                    const check = this.model.filter(
                        (x) => x.label === "Reports"
                    );
                    const index = this.model.indexOf(check[0]);
                    if (check.length > 0) {
                        this.model[index].items.push({
                            label: "Session Sales Report",
                            icon: "content_copy",
                            routerLink: ["reports/session-sales-report"],
                        });
                    } else {
                        this.model.push({
                            label: "Reports",
                            icon: "insert_chart",
                            items: [
                                {
                                    label: "Session Sales Report",
                                    icon: "content_copy",
                                    routerLink: ["reports/session-sales-report"],
                                },
                            ],
                        });
                    }
                }
                if (
                    permission.pageType === "Reports" &&
                    permission.pageName === "Self Session Report"
                ) {
                    const check = this.model.filter(
                        (x) => x.label === "Reports"
                    );
                    const index = this.model.indexOf(check[0]);
                    if (check.length > 0) {
                        this.model[index].items.push({
                            label: "Self Session Report",
                            icon: "content_copy",
                            routerLink: ["reports/selfSession-report"],
                        });
                    } else {
                        this.model.push({
                            label: "Reports",
                            icon: "insert_chart",
                            items: [
                                {
                                    label: "Self Session Report",
                                    icon: "content_copy",
                                    routerLink: ["reports/selfSession-report"],
                                },
                            ],
                        });
                    }
                }
                if (
                    permission.pageType === "Reports" &&
                    permission.pageName === "Visitor Report"
                ) {
                    const check = this.model.filter(
                        (x) => x.label === "Reports"
                    );
                    const index = this.model.indexOf(check[0]);
                    if (check.length > 0) {
                        this.model[index].items.push({
                            label: "Visitor Report",
                            icon: "content_copy",
                            routerLink: ["reports/visitor-report"],
                        });
                    } else {
                        this.model.push({
                            label: "Reports",
                            icon: "insert_chart",
                            items: [
                                {
                                    label: "Visitor Report",
                                    icon: "content_copy",
                                    routerLink: ["reports/visitor-report"],
                                },
                            ],
                        });
                    }
                }
                if (
                    permission.pageType === "Reports" &&
                    permission.pageName === "Request Management"
                ) {
                    const check = this.model.filter(
                        (x) => x.label === "Reports"
                    );
                    const index = this.model.indexOf(check[0]);
                    if (check.length > 0) {
                        this.model[index].items.push({
                            label: "Request Management",
                            icon: "content_copy",
                            routerLink: ["reports/request-management-report"],
                        });
                    } else {
                        this.model.push({
                            label: "Reports",
                            icon: "insert_chart",
                            items: [
                                {
                                    label: "Request Management",
                                    icon: "content_copy",
                                    routerLink: ["reports/request-management-report"],
                                },
                            ],
                        });
                    }
                }
                if (
                    permission.pageType === "Reports" &&
                    permission.pageName === "Purchase History"
                ) {
                    const check = this.model.filter(
                        (x) => x.label === "Reports"
                    );
                    const index = this.model.indexOf(check[0]);
                    if (check.length > 0) {
                        this.model[index].items.push({
                            label: "Purchase History",
                            icon: "content_copy",
                            routerLink: ["reports/purchase-history-report"],
                        });
                    } else {
                        this.model.push({
                            label: "Reports",
                            icon: "insert_chart",
                            items: [
                                {
                                    label: "Purchase History",
                                    icon: "content_copy",
                                    routerLink: ["reports/purchase-history-report"],
                                },
                            ],
                        });
                    }
                }
                if (
                    permission.pageType === "Reports" &&
                    permission.pageName === "POS Sales Report"
                ) {
                    const check = this.model.filter(
                        (x) => x.label === "Reports"
                    );
                    const index = this.model.indexOf(check[0]);
                    if (check.length > 0) {
                        this.model[index].items.push({
                            label: "POS Sales Report",
                            icon: "content_copy",
                            routerLink: ["reports/pos-sales-report"],
                        });
                    } else {
                        this.model.push({
                            label: "Reports",
                            icon: "insert_chart",
                            items: [
                                {
                                    label: "POS Sales Report",
                                    icon: "content_copy",
                                    routerLink: ["reports/pos-sales-report"],
                                },
                            ],
                        });
                    }
                }
                if (
                    permission.pageType === "Reports" &&
                    permission.pageName === "Balance Sheet Report"
                ) {
                    const check = this.model.filter(
                        (x) => x.label === "Reports"
                    );
                    const index = this.model.indexOf(check[0]);
                    if (check.length > 0) {
                        this.model[index].items.push({
                            label: "Balance Sheet Report",
                            icon: "content_copy",
                            routerLink: ["reports/balance-sheet-report"],
                        });
                    } else {
                        this.model.push({
                            label: "Reports",
                            icon: "insert_chart",
                            items: [
                                {
                                    label: "Balance Sheet Report",
                                    icon: "content_copy",
                                    routerLink: ["reports/balance-sheet-report"],
                                },
                            ],
                        });
                    }
                }
                if (
                    permission.pageType === "Reports" &&
                    permission.pageName === "Upcoming Dues"
                ) {
                    const check = this.model.filter(
                        (x) => x.label === "Reports"
                    );
                    const index = this.model.indexOf(check[0]);
                    if (check.length > 0) {
                        this.model[index].items.push({
                            label: "Upcoming Dues",
                            icon: "content_copy",
                            routerLink: ["reports/upcoming-dues-report"],
                        });
                    } else {
                        this.model.push({
                            label: "Upcoming Dues",
                            icon: "insert_chart",
                            items: [
                                {
                                    label: "Upcoming Dues",
                                    icon: "content_copy",
                                    routerLink: ["reports/upcoming-dues-report"],
                                },
                            ],
                        });
                    }
                }
                if (
                    permission.pageType === "Reports" &&
                    permission.pageName === "Upcoming Birthdays"
                ) {
                    const check = this.model.filter(
                        (x) => x.label === "Reports"
                    );
                    const index = this.model.indexOf(check[0]);
                    if (check.length > 0) {
                        this.model[index].items.push({
                            label: "Upcoming Birthdays",
                            icon: "content_copy",
                            routerLink: ["reports/upcoming-birthdays-report"],
                        });
                    } else {
                        this.model.push({
                            label: "Upcoming Birthdays",
                            icon: "insert_chart",
                            items: [
                                {
                                    label: "Upcoming Birthdays",
                                    icon: "content_copy",
                                    routerLink: ["reports/upcoming-birthdays-report"],
                                },
                            ],
                        });
                    }
                }
                if (
                    permission.pageType === "Reports" &&
                    permission.pageName === "Salary Issue Report"
                ) {
                    const check = this.model.filter(
                        (x) => x.label === "Reports"
                    );
                    const index = this.model.indexOf(check[0]);
                    if (check.length > 0) {
                        this.model[index].items.push({
                            label: "Salary Issue Report",
                            icon: "content_copy",
                            routerLink: ["reports/salary-issue-report"],
                        });
                    } else {
                        this.model.push({
                            label: "Salary Issue Report",
                            icon: "insert_chart",
                            items: [
                                {
                                    label: "Salary Issue Report",
                                    icon: "content_copy",
                                    routerLink: ["reports/salary-issue-report"],
                                },
                            ],
                        });
                    }
                }


                if (
                    permission.pageType === "Reports" &&
                    permission.pageName === "Check-In Report"
                ) {
                    const check = this.model.filter(
                        (x) => x.label === permission.pageType
                    );
                    const index = this.model.indexOf(check[0]);
                    if (check.length > 0) {
                        this.model[index].items.push({
                            label: permission.pageName,
                            icon: permission.icon,
                            routerLink: ['reports/' + permission.pageUrl],
                        });
                    } else {
                        this.model.push({
                            label: permission.pageType,
                            icon: "insert_chart",
                            items: [
                                {
                                    label: permission.pageName,
                                    icon: permission.icon,
                                    routerLink: ['reports/' + permission.pageUrl],
                                },
                            ],
                        });
                    }
                }
                if (
                    permission.pageType === "Reports" &&
                    permission.pageName === "Members Attendance"
                ) {
                    const check = this.model.filter(
                        (x) => x.label === permission.pageType
                    );
                    const index = this.model.indexOf(check[0]);
                    if (check.length > 0) {
                        this.model[index].items.push({
                            label: permission.pageName,
                            icon: permission.icon,
                            routerLink: ['reports/' + permission.pageUrl],
                        });
                    } else {
                        this.model.push({
                            label: permission.pageType,
                            icon: "insert_chart",
                            items: [
                                {
                                    label: permission.pageName,
                                    icon: permission.icon,
                                    routerLink: ['reports/' + permission.pageUrl],
                                },
                            ],
                        });
                    }
                }
                if (
                    permission.pageType === "Reports" &&
                    permission.pageName === "Employees Attendance"
                ) {
                    const check = this.model.filter(
                        (x) => x.label === permission.pageType
                    );
                    const index = this.model.indexOf(check[0]);
                    if (check.length > 0) {
                        this.model[index].items.push({
                            label: permission.pageName,
                            icon: permission.icon,
                            routerLink: ['reports/' + permission.pageUrl],
                        });
                    } else {
                        this.model.push({
                            label: permission.pageType,
                            icon: "insert_chart",
                            items: [
                                {
                                    label: permission.pageName,
                                    icon: permission.icon,
                                    routerLink: ['reports/' + permission.pageUrl],
                                },
                            ],
                        });
                    }
                }
                if (
                    permission.pageType === "User Attendance" &&
                    permission.pageName === "User Attendance"
                ) {
                    this.model.push({
                        label: permission.pageName,
                        icon: permission.icon || "event_available",
                        routerLink: ["/user-attendance"],
                    });
                }

                if (
                    permission.pageType === "Reports" &&
                    permission.pageName === "Trainers Attendance Report"
                ) {
                    const check = this.model.filter(
                        (x) => x.label === permission.pageType
                    );
                    const index = this.model.indexOf(check[0]);
                    if (check.length > 0) {
                        this.model[index].items.push({
                            label: permission.pageName,
                            icon: permission.icon,
                            routerLink: ['reports/' + permission.pageUrl],
                        });
                    } else {
                        this.model.push({
                            label: permission.pageType,
                            icon: permission.icon,
                            items: [
                                {
                                    label: permission.pageName,
                                    icon: permission.icon,
                                    routerLink: ['reports/' + permission.pageUrl],
                                },
                            ],
                        });
                    }
                }

                if (
                    permission.pageType === "Reports" &&
                    permission.pageName === "Admission Fees Report"
                ) {
                    const check = this.model.filter(
                        (x) => x.label === "Reports"
                    );
                    const index = this.model.indexOf(check[0]);
                    if (check.length > 0) {
                        this.model[index].items.push({
                            label: "Admission Fees Report",
                            icon: "content_copy",
                            routerLink: ["reports/admission-Report"],
                        });
                    } else {
                        this.model.push({
                            label: "Reports",
                            icon: "insert_chart",
                            items: [
                                {
                                    label: "Admission Fees Report",
                                    icon: "content_copy",
                                    routerLink: ["reports/admission-Report"],
                                },
                            ],
                        });
                    }
                }
                if (
                    permission.pageType === "Reports" &&
                    permission.pageName === "Defaulter Report"
                ) {
                    const check = this.model.filter(
                        (x) => x.label === "Reports"
                    );
                    const index = this.model.indexOf(check[0]);
                    if (check.length > 0) {
                        this.model[index].items.push({
                            label: permission.pageName,
                            icon: "content_copy",
                            routerLink: ["reports/defaulter-Report"],
                        });
                    } else {
                        this.model.push({
                            label: "Reports",
                            icon: "insert_chart",
                            items: [
                                {
                                    label: "Defaulter Report",
                                    icon: "content_copy",
                                    routerLink: ["reports/defaulter-Report"],
                                },
                            ],
                        });
                    }
                }
                if (
                    permission.pageType === "Reports" &&
                    (permission.pageName === "Subscription Defaulter Report" ||
                        permission.pageName === "Subscription Defaulter")
                ) {
                    const check = this.model.filter(
                        (x) => x.label === "Reports"
                    );
                    const index = this.model.indexOf(check[0]);
                    if (check.length > 0) {
                        const exists = this.model[index].items?.some(
                            (item: any) =>
                                Array.isArray(item.routerLink) &&
                                item.routerLink[0] === "reports/subscription-defaulter-report"
                        );
                        if (!exists) {
                            this.model[index].items.push({
                                label: "Subscription Defaulter",
                                icon: "content_copy",
                                routerLink: ["reports/subscription-defaulter-report"],
                            });
                        }
                    } else {
                        this.model.push({
                            label: "Reports",
                            icon: "insert_chart",
                            items: [
                                {
                                    label: "Subscription Defaulter",
                                    icon: "content_copy",
                                    routerLink: ["reports/subscription-defaulter-report"],
                                },
                            ],
                        });
                    }
                }
                // if (
                //     permission.pageType === "Reports" &&
                //     permission.pageName === "Trainer Defaulter Report"
                // ) {
                //     const check = this.model.filter(
                //         (x) => x.label === "Reports"
                //     );
                //     const index = this.model.indexOf(check[0]);
                //     if (check.length > 0) {
                //         this.model[index].items.push({
                //             label: permission.pageName,
                //             icon: "content_copy",
                //             routerLink: ["reports/trainer-defaulter-report"],
                //         });
                //     } else {
                //         this.model.push({
                //             label: "Reports",
                //             icon: "insert_chart",
                //             items: [
                //                 {
                //                     label: "Trainer Defaulter Report",
                //                     icon: "content_copy",
                //                     routerLink: ["reports/trainer-defaulter-report"],
                //                 },
                //             ],
                //         });
                //     }
                // }
                if (
                    permission.pageType === "Reports" &&
                    permission.pageName === "Trainers Attendance"
                ) {
                    const check = this.model.filter(
                        (x) => x.label === "Reports"
                    );
                    const index = this.model.indexOf(check[0]);
                    if (check.length > 0) {
                        this.model[index].items.push({
                            label: permission.pageName,
                            icon: "content_copy",
                            routerLink: ["reports/training-attendence-Report"],
                        });
                    } else {
                        this.model.push({
                            label: "Reports",
                            icon: "insert_chart",
                            items: [
                                {
                                    label: "Trainers Attendance",
                                    icon: "content_copy",
                                    routerLink: ["reports/training-attendence-Report"],
                                },
                            ],
                        });
                    }
                }

                if (
                    permission.pageType === "Setting" &&
                    permission.pageName === "User Management"
                ) {
                    const check = this.model.filter(
                        (x) => x.label === "Settings"
                    );
                    const index = this.model.indexOf(check[0]);
                    if (check.length > 0) {
                        this.model[index].items.push({
                            label: "User Management",
                            icon: "group",
                            routerLink: ["/settings"],
                        });
                    } else {
                        this.model.push({
                            label: "Settings",
                            icon: "settings_application",
                            items: [
                                {
                                    label: "User Management",
                                    icon: "group",
                                    routerLink: ["/settings"],
                                },
                            ],
                        });
                    }
                }
                if (
                    permission.pageType === "Setting" &&
                    permission.pageName === "Roles Management"
                ) {
                    const check = this.model.filter(
                        (x) => x.label === "Settings"
                    );
                    const index = this.model.indexOf(check[0]);
                    if (check.length > 0) {
                        this.model[index].items.push({
                            label: "Role Management",
                            icon: "verified_user",
                            routerLink: ["/settings/roles"],
                        });
                    } else {
                        this.model.push({
                            label: "Settings",
                            icon: "settings_application",
                            items: [
                                {
                                    label: "Role Management",
                                    icon: "verified_user",
                                    routerLink: ["/settings/roles"],
                                },
                            ],
                        });
                    }
                }
                if (
                    permission.pageType === "Setting" &&
                    permission.pageName === "Permissions Management"
                ) {
                    const check = this.model.filter(
                        (x) => x.label === "Settings"
                    );
                    const index = this.model.indexOf(check[0]);
                    if (check.length > 0) {
                        this.model[index].items.push({
                            label: "Permission Management",
                            icon: "security",
                            routerLink: ["/settings/permissions"],
                        });
                    } else {
                        this.model.push({
                            label: "Settings",
                            icon: "settings_application",
                            items: [
                                {
                                    label: "Permission Management",
                                    icon: "security",
                                    routerLink: ["/settings/permissions"],
                                },
                            ],
                        });
                    }
                }
                if (
                    permission.pageType === "Setting" &&
                    permission.pageName === "Branch Management"
                ) {
                    const check = this.model.filter(
                        (x) => x.label === "Settings"
                    );
                    const index = this.model.indexOf(check[0]);
                    if (check.length > 0) {
                        this.model[index].items.push({
                            label: "Branch Management",
                            icon: "store-mall-directory",
                            routerLink: ["/settings/branches"],
                        });
                    } else {
                        this.model.push({
                            label: "Settings",
                            icon: "settings_application",
                            items: [
                                {
                                    label: "Branch Management",
                                    icon: "store-mall-directory",
                                    routerLink: ["/settings/branches"],
                                },
                            ],
                        });
                    }
                }
                if (
                    permission.pageType === "Setting" &&
                    permission.pageName === "Company Management"
                ) {
                    const check = this.model.filter(
                        (x) => x.label === "Settings"
                    );
                    const index = this.model.indexOf(check[0]);
                    if (check.length > 0) {
                        this.model[index].items.push({
                            label: "Company Management",
                            icon: "build",
                            routerLink: ["/settings/companies"],
                        });
                    } else {
                        this.model.push({
                            label: "Settings",
                            icon: "settings_application",
                            items: [
                                {
                                    label: "Company Management",
                                    icon: "build",
                                    routerLink: ["/settings/companies"],
                                },
                            ],
                        });
                    }
                }
                if (
                    permission.pageType === "Setting" &&
                    permission.pageName === "Attendance Management"
                ) {
                    const check = this.model.filter(
                        (x) => x.label === "Settings"
                    );
                    const index = this.model.indexOf(check[0]);
                    if (check.length > 0) {
                        this.model[index].items.push({
                            label: "Attendance Management",
                            icon: "build",
                            routerLink: ["/settings/employeesAttendance"],
                        });
                    } else {
                        this.model.push({
                            label: "Settings",
                            icon: "settings_application",
                            items: [
                                {
                                    label: "Attendance Management",
                                    icon: "build",
                                    routerLink: ["/settings/employeesAttendance"],
                                },
                            ],
                        });
                    }
                }
                if (
                    permission.pageType === "Setting" &&
                    permission.pageName === "Global Settings"
                ) {
                    const check = this.model.filter(
                        (x) => x.label === "Settings"
                    );
                    const index = this.model.indexOf(check[0]);
                    if (check.length > 0) {
                        this.model[index].items.push({
                            label: "Global Settings",
                            icon: "build",
                            routerLink: ["/globals"],
                        });
                    } else {
                        this.model.push({
                            label: "Settings",
                            icon: "settings_application",
                            items: [
                                {
                                    label: "Global Settings",
                                    icon: "build",
                                    routerLink: ["/globals"],
                                },
                            ],
                        });
                    }
                }
                // Training Attendence Menu
                if (
                    permission.pageType === "Training Attendance" &&
                    permission.pageName === "Training Attendance"
                ) {
                    const check = this.model.filter(
                        (x) => x.label === "Training Attendance"
                    );
                    const index = this.model.indexOf(check[0]);
                    if (check.length > 0) {
                        this.model[index].items.push({
                            label: "Training Attendance",
                            icon: "hourglass_empty",
                            routerLink: ["/trainer/members-attendence"],
                        });
                    } else {
                        this.model.push({
                            label: "Training Attendance",
                            icon: "hourglass_empty",
                            items: [
                                {
                                    label: "Training Attendance",
                                    icon: "hourglass_empty",
                                    routerLink: ["/trainer/members-attendence"],
                                },
                            ],
                        });
                    }
                }
                if (permission.pageType === "Training Sessions") {
                    this.model.push({
                        label: "Training Sessions",
                        icon: "hourglass_empty",
                        routerLink: ["/training-sessions"],
                    });
                }
                if (permission.pageType === "Session Attendance") {
                    this.model.push({
                        label: "Session Attendance",
                        icon: "assignment_turned_in",
                        routerLink: ["/session-attendance"],
                    });
                }
                if (permission.pageType === "Self Sessions") {
                    this.model.push({
                        label: "Self Sessions",
                        icon: "hourglass_empty",
                        routerLink: ["/self-sessions"],
                    });
                }
                if (permission.pageType === "Trainer Dashboard") {
                    this.model.push({
                        label: "Trainer Dashboard",
                        icon: "hourglass_empty",
                        routerLink: ["/trainer-dashboard"],
                    });
                }

                // Training Session Menu
                if (
                    permission.pageType === "Reports" &&
                    permission.pageName === "Training Session"
                ) {
                    const check = this.model.filter(
                        (x) => x.label === "Reports"
                    );
                    const index = this.model.indexOf(check[0]);
                    if (check.length > 0) {
                        this.model[index].items.push({
                            label: "Training Session",
                            icon: "content_copy",
                            routerLink: ["/reports/trainer-session-report"],
                        });
                    } else {
                        this.model.push({
                            label: "Reports",
                            icon: "insert_chart",
                            items: [
                                {
                                    label: "Training Session",
                                    icon: "content_copy",
                                    routerLink: ["/reports/trainer-session-report"],
                                },
                            ],
                        });
                    }
                }

                // Member Report
                if (
                    permission.pageType === "Reports" &&
                    permission.pageName === "Member Report"
                ) {
                    const check = this.model.filter(
                        (x) => x.label === "Reports"
                    );
                    const index = this.model.indexOf(check[0]);
                    if (check.length > 0) {
                        this.model[index].items.push({
                            label: "Member Report",
                            icon: "content_copy",
                            routerLink: ["reports/member-report"],
                        });
                    } else {
                        this.model.push({
                            label: "Reports",
                            icon: "insert_chart",
                            items: [
                                {
                                    label: "Member Report",
                                    icon: "content_copy",
                                    routerLink: ["reports/member-report"],
                                },
                            ],
                        });
                    }
                }
                // freeze Member Report
                if (
                    permission.pageType === "Reports" &&
                    permission.pageName === "Freezed Members"
                ) {
                    const check = this.model.filter(
                        (x) => x.label === "Reports"
                    );
                    const index = this.model.indexOf(check[0]);
                    if (check.length > 0) {
                        this.model[index].items.push({
                            label: "Freezed Members",
                            icon: "content_copy",
                            routerLink: ["reports/freeze-member-report"],
                        });
                    } else {
                        this.model.push({
                            label: "Reports",
                            icon: "insert_chart",
                            items: [
                                {
                                    label: "Freezed Members",
                                    icon: "content_copy",
                                    routerLink: ["reports/Freeze-member-report"],
                                },
                            ],
                        });
                    }
                }
// New Member Report
                 if (
                     permission.pageType === "Reports" &&
                     permission.pageName === "New Member Report"
                 ) {
                     const check = this.model.filter(
                         (x) => x.label === "Reports"
                     );
                     const index = this.model.indexOf(check[0]);
                     if (check.length > 0) {
                         this.model[index].items.push({
                             label: "New Member Report",
                             icon: "content_copy",
                             routerLink: ["reports/new-member-report"],
                         });
                     } else {
                         this.model.push({
                             label: "Reports",
                             icon: "insert_chart",
                             items: [
                                 {
                                     label: "New Member Report",
                                     icon: "content_copy",
                                     routerLink: ["reports/new member-report"],
                                 },
                             ],
                         });
                     }
                 }
         // Member Report
                // if (
                //     permission.pageType === "Reports" &&
                //     permission.pageName === "Member Report"
                // ) {
                //     const check = this.model.filter(
                //         (x) => x.label === "Reports"
                //     );
                //     const index = this.model.indexOf(check[0]);
                //     if (check.length > 0) {
                //         this.model[index].items.push({
                //             label: "Member Report",
                //             icon: "content_copy",
                //             routerLink: ["reports/member-report"],
                //         });
                //     } else {
                //         this.model.push({
                //             label: "Reports",
                //             icon: "insert_chart",
                //             items: [
                //                 {
                //                     label: "Member Report",
                //                     icon: "content_copy",
                //                     routerLink: ["reports/member-report"],
                //                 },
                //             ],
                //         });
                //     }
                // }

                // EmployeeData Report
                if (
                    permission.pageType === "Reports" &&
                    permission.pageName === "EmployeeData"
                ) {
                    const check = this.model.filter(
                        (x) => x.label === "Reports"
                    );
                    const index = this.model.indexOf(check[0]);
                    if (check.length > 0) {
                        this.model[index].items.push({
                            label: "EmployeeData",
                            icon: "content_copy",
                            routerLink: ["reports/EmployeeData"],
                        });
                    } else {
                        this.model.push({
                            label: "Reports",
                            icon: "insert_chart",
                            items: [
                                {
                                    label: "EmployeeData",
                                    icon: "content_copy",
                                    routerLink: ["reports/EmployeeData"],
                                },
                            ],
                        });
                    }
                }
                if (
                    permission.pageType === "Reports" &&
                    permission.pageName === "Active Member"
                ) {
                    const check = this.model.filter(
                        (x) => x.label === "Reports"
                    );
                    const index = this.model.indexOf(check[0]);
                    if (check.length > 0) {
                        this.model[index].items.push({
                            label: "Active Member",
                            icon: "content_copy",
                            routerLink: ["reports/active-member-report"],
                        });
                    } else {
                        this.model.push({
                            label: "Reports",
                            icon: "insert_chart",
                            items: [
                                {
                                    label: "Active Member",
                                    icon: "content_copy",
                                    routerLink: ["reports/active-member-report"],
                                },
                            ],
                        });
                    }
                }
                if (
                    permission.pageType === "Reports" &&
                    permission.pageName === "InActive Member"
                ) {
                    const check = this.model.filter(
                        (x) => x.label === "Reports"
                    );
                    const index = this.model.indexOf(check[0]);
                    if (check.length > 0) {
                        this.model[index].items.push({
                            label: "InActive Member",
                            icon: "content_copy",
                            routerLink: ["reports/inactive-member-report"],
                        });
                    } else {
                        this.model.push({
                            label: "Reports",
                            icon: "insert_chart",
                            items: [
                                {
                                    label: "InActive Member",
                                    icon: "content_copy",
                                    routerLink: ["reports/inactive-member-report"],
                                },
                            ],
                        });
                    }
                }
                if (
                    permission.pageType === "Reports" &&
                    permission.pageName === "Enquiry Management"
                ) {
                    const check = this.model.filter(
                        (x) => x.label === "Reports"
                    );
                    const index = this.model.indexOf(check[0]);
                    if (check.length > 0) {
                        this.model[index].items.push({
                            label: "Enquiry Management",
                            icon: "content_copy",
                            routerLink: ["reports/enquiry-management-report"],
                        });
                    } else {
                        this.model.push({
                            label: "Reports",
                            icon: "insert_chart",
                            items: [
                                {
                                    label: "Enquiry Management",
                                    icon: "content_copy",
                                    routerLink: ["reports/enquiry-management-report"],
                                },
                            ],
                        });
                    }
                }
             //   Trainer Defaulter Report
                if (
                    permission.pageType === "Reports" &&
                    permission.pageName === "Trainer defaulter"
                ) {
                    const check = this.model.filter(
                        (x) => x.label === "Reports"
                    );
                    const index = this.model.indexOf(check[0]);
                    if (check.length > 0) {
                        const exists = this.model[index].items?.some(
                            (item: any) =>
                                Array.isArray(item.routerLink) &&
                                item.routerLink[0] === "reports/trainer-defaulter"
                        );
                        if (!exists) {
                            this.model[index].items.push({
                                label: permission.pageName,
                                icon: "content_copy",
                                routerLink: ["reports/trainer-defaulter"],
                            });
                        }
                    } else {
                        this.model.push({
                            label: "Reports",
                            icon: "insert_chart",
                            items: [
                                {
                                    label: permission.pageName,
                                    icon: "content_copy",
                                    routerLink: ["reports/trainer-defaulter"],
                                },
                            ],
                        });
                    }
                }

                // Complains (tickets / support)
                if (
                    permission.pageType === "Support" &&
                   permission.pageName === "Complains"
                ) {
                    const check = this.model.filter(
                        (x) => x.label === "Support"
                    );
                    const index = this.model.indexOf(check[0]);
                    if (check.length > 0) {
                        const exists = this.model[index].items?.some(
                            (item: any) =>
                                Array.isArray(item.routerLink) &&
                                item.routerLink[0] === "complains"
                        );
                        if (!exists) {
                            this.model[index].items.push({
                                label: permission.pageName,
                                icon: "content_copy",
                                routerLink: ["complains"],
                            });
                        }
                    } else {
                        this.model.push({
                            label: "Support",
                            icon: "insert_chart",
                            items: [
                                {
                                    label: permission.pageName,
                                    icon: "content_copy",
                                    routerLink: ["complains"],
                                },
                            ],
                        });
                    }
                }

                // Daily Closing Report
                // if (
                //     permission.pageType === "Reports" &&
                //     permission.pageName === "Daily Closing Report"
                // ) {
                //     const check = this.model.filter(
                //         (x) => x.label === "Reports"
                //     );
                //     const index = this.model.indexOf(check[0]);
                //     if (check.length > 0) {
                //         this.model[index].items.push({
                //             label: "Daily Closing Report",
                //             icon: "content_copy",
                //             routerLink: ["reports/daily-closing-report"],
                //         });
                //     } else {
                //         this.model.push({
                //             label: "Reports",
                //             icon: "insert_chart",
                //             items: [
                //                 {
                //                     label: "Daily Closing Report",
                //                     icon: "content_copy",
                //                     routerLink: ["reports/daily-closing-report"],
                //                 },
                //             ],
                //         });
                //     }
                // }
                if (
                    permission.pageType === "Reports" &&
                    permission.pageName === "Daily Closing"
                ) {
                    const check = this.model.filter(
                        (x) => x.label === "Reports"
                    );
                    const index = this.model.indexOf(check[0]);
                    if (check.length > 0) {
                        this.model[index].items.push({
                            label: "Daily Closing",
                            icon: "content_copy",
                            routerLink: ["reports/daily-closing"],
                        });
                    } else {
                        this.model.push({
                            label: "Reports",
                            icon: "insert_chart",
                            items: [
                                {
                                    label: "Daily Closing",
                                    icon: "content_copy",
                                    routerLink: ["reports/daily-closing"],
                                },
                            ],
                        });
                    }
                }
                if (
                    permission.pageType === "Reports" &&
                    permission.pageName === "Closing Report"
                ) {
                    const check = this.model.filter(
                        (x) => x.label === "Reports"
                    );
                    const index = this.model.indexOf(check[0]);
                    if (check.length > 0) {
                        this.model[index].items.push({
                            label: "Closing Report",
                            icon: "content_copy",
                            routerLink: ["reports/closing-report"],
                        });
                    } else {
                        this.model.push({
                            label: "Reports",
                            icon: "closing-report",
                            items: [
                                {
                                    label: "Closing Report",
                                    icon: "content_copy",
                                    routerLink: ["reports/closing-report"],
                                },
                            ],
                        });
                    }
                }

                if (permission.pageType === "Locked List") {
                    this.model.push({
                        label: "Locked List",
                        icon: "group",
                        routerLink: ["/locked-listing"],
                    });
                }

                if (permission.pageType === "Petty Cash") {
                    this.model.push({
                        label: "Petty Cash",
                        icon: "group",
                        routerLink: ["/petty-cash"],
                    });
                }


                // Suppliers
                if (
                    permission.pageType === "Purchasing" &&
                    permission.pageName === "Suppliers"
                ) {
                    const check = this.model.filter(
                        (x) => x.label === "Purchasing"
                    );
                    const index = this.model.indexOf(check[0]);
                    if (check.length > 0) {
                        this.model[index].items.push({
                            label: "Suppliers",
                            icon: "content_copy",
                            routerLink: ["/suppliers-listing"],
                        });
                    } else {
                        this.model.push({
                            label: "Purchasing",
                            icon: "insert_chart",
                            items: [
                                {
                                    label: "Suppliers",
                                    icon: "content_copy",
                                    routerLink: ["/suppliers-listing"],
                                },
                            ],
                        });
                    }
                }

                // Purchase Order
                if (
                    permission.pageType === "Purchasing" &&
                    permission.pageName === "Purchase Order"
                ) {
                    const check = this.model.filter(
                        (x) => x.label === "Purchasing"
                    );
                    const index = this.model.indexOf(check[0]);
                    if (check.length > 0) {
                        this.model[index].items.push({
                            label: "Purchase Order",
                            icon: "content_copy",
                            routerLink: ["/purchase-order"],
                        });
                    } else {
                        this.model.push({
                            label: "Purchasing",
                            icon: "insert_chart",
                            items: [
                                {
                                    label: "Purchase Order",
                                    icon: "content_copy",
                                    routerLink: ["/purchase-order"],
                                },
                            ],
                        });
                    }
                }

                 // Purchase Orders
                 if (
                    permission.pageType === "Purchasing" &&
                    permission.pageName === "Purchase Orders"
                ) {
                    const check = this.model.filter(
                        (x) => x.label === "Purchasing"
                    );
                    const index = this.model.indexOf(check[0]);
                    if (check.length > 0) {
                        this.model[index].items.push({
                            label: "Purchase Orders",
                            icon: "content_copy",
                            routerLink: ["/purchase-orders"],
                        });
                    } else {
                        this.model.push({
                            label: "Purchasing",
                            icon: "insert_chart",
                            items: [
                                {
                                    label: "Purchase Orders",
                                    icon: "content_copy",
                                    routerLink: ["/purchase-orders"],
                                },
                            ],
                        });
                    }
                }

                if (
    permission.pageType === "Products" &&
    (permission.pageName === "Products Categories" ||
        permission.pageName === "Products Listing")
) {
    const check = this.model.filter(
        (x) => x.label === "Products"
    );
    const index = this.model.indexOf(check[0]);

    const categoryItem = {
        label: "Products Categories",
        icon: "content_copy",
        routerLink: ["/product-categories"],
    };

    if (check.length > 0) {
        const hasCategory = this.model[index].items.some(
            (item: any) => item.label === "Products Categories"
        );
        if (!hasCategory) {
            this.model[index].items.push(categoryItem);
        }
    } else {
        this.model.push({
            label: "Products",
            icon: "insert_chart",
            items: [categoryItem],
        });
    }

    if (permission.pageName === "Products Listing") {
        const productsMenu = this.model.find(
            (x) => x.label === "Products"
        );

        const hasListing = productsMenu.items.some(
            (item: any) => item.label === "Products Listing"
        );

        if (!hasListing) {
            productsMenu.items.unshift({
                label: "Products Listing",
                icon: "content_copy",
                routerLink: ["/products-listing"],
            });
        }
    }
}

                if (
                    permission.pageType === "Products" &&
                    permission.pageName === "Update Products Inventory"
                ) {
                    const check = this.model.filter(
                        (x) => x.label === "Products"
                    );
                    const index = this.model.indexOf(check[0]);
                    if (check.length > 0) {
                        this.model[index].items.push({
                            label: "Update Products Inventory",
                            icon: "content_copy",
                            routerLink: ["/update-products-inventory"],
                        });
                    } else {
                        this.model.push({
                            label: "Products",
                            icon: "insert_chart",
                            items: [
                                {
                                    label: "Update Products Inventory",
                                    icon: "content_copy",
                                    routerLink: ["/update-products-inventory"],
                                },
                            ],
                        });
                    }
                }

                if (
                    permission.pageType === "Sales" &&
                    permission.pageName === "Point of Sales"
                ) {
                    const check = this.model.filter(
                        (x) => x.label === "Sales"
                    );
                    const index = this.model.indexOf(check[0]);
                    if (check.length > 0) {
                        this.model[index].items.push({
                            label: "Point of Sales",
                            icon: "content_copy",
                            routerLink: ["/point-of-sale"],
                        });
                    } else {
                        this.model.push({
                            label: "Sales",
                            icon: "insert_chart",
                            items: [
                                {
                                    label: "Point of Sales",
                                    icon: "content_copy",
                                    routerLink: ["/point-of-sale"],
                                },
                            ],
                        });
                    }
                }
                if (
                    permission.pageType === "Sales" &&
                    permission.pageName === "Quotations"
                ) {
                    const check = this.model.filter(
                        (x) => x.label === "Sales"
                    );
                    const index = this.model.indexOf(check[0]);
                    if (check.length > 0) {
                        this.model[index].items.push({
                            label: "Quotations",
                            icon: "content_copy",
                            routerLink: ["sales/quotations"],
                        });
                    } else {
                        this.model.push({
                            label: "Sales",
                            icon: "insert_chart",
                            items: [
                                {
                                    label: "Quotations",
                                    icon: "content_copy",
                                    routerLink: ["sales/quotations"],
                                },
                            ],
                        });
                    }
                }

                if (
                    permission.pageType === "Sales" &&
                    permission.pageName === "Sale Orders"
                ) {
                    const check = this.model.filter(
                        (x) => x.label === "Sales"
                    );
                    const index = this.model.indexOf(check[0]);
                    if (check.length > 0) {
                        this.model[index].items.push({
                            label: "Sale Orders",
                            icon: "content_copy",
                            routerLink: ["/sale-orders"],
                        });
                    } else {
                        this.model.push({
                            label: "Sales",
                            icon: "insert_chart",
                            items: [
                                {
                                    label: "Sale Orders",
                                    icon: "content_copy",
                                    routerLink: ["/sale-orders"],
                                },
                            ],
                        });
                    }
                }

                if (
                    permission.pageType === "HR Management" &&
                    permission.pageName === "Designation Management"
                ) {
                    const check = this.model.filter(
                        (x) => x.label === "HR Management"
                    );
                    const index = this.model.indexOf(check[0]);
                    if (check.length > 0) {
                        this.model[index].items.push({
                            label: "Designation Management",
                            icon: "content_copy",
                            routerLink: ["/designation-management"],
                        });
                    } else {
                        this.model.push({
                            label: "HR Management",
                            icon: "insert_chart",
                            items: [
                                {
                                    label: "Designation Management",
                                    icon: "content_copy",
                                    routerLink: ["/designation-management"],
                                },
                            ],
                        });
                    }
                }
                if (
                    permission.pageType === "HR Management" &&
                    permission.pageName === "Employees Listing"
                ){
                    const check = this.model.filter(
                        (x) => x.label === "HR Management"
                    );
                    const index = this.model.indexOf(check[0]);
                    if (check.length > 0) {
                        this.model[index].items.push({
                            label: "Employees Listing",
                            icon: "content_copy",
                            routerLink: ["/employees-listing"],
                        });
                    } else {
                        this.model.push({
                            label: "HR Management",
                            icon: "insert_chart",
                            items: [
                                {
                                    label: "Employees Listing",
                                    icon: "content_copy",
                                    routerLink: ["/employees-listing"],
                                },
                            ],
                        });
                    }
                }

                if (
                    permission.pageType === "HR Management" &&
                    permission.pageName === "Issue Salary"
                ){
                    const check = this.model.filter(
                        (x) => x.label === "HR Management"
                    );
                    const index = this.model.indexOf(check[0]);
                    if (check.length > 0) {
                        this.model[index].items.push({
                            label: "Issue Salary",
                            icon: "content_copy",
                            routerLink: ["/issue-salary"],
                        });
                    } else {
                        this.model.push({
                            label: "HR Management",
                            icon: "insert_chart",
                            items: [
                                {
                                    label: "Issue Salary",
                                    icon: "content_copy",
                                    routerLink: ["/issue-salary"],
                                },
                            ],
                        });
                    }
                }
                if (
                    permission.pageType === "Reports" &&
                    permission.pageName === "Package Overview Report"
                ) {
                    const check = this.model.filter(
                        (x) => x.label === "Reports"
                    );
                    const index = this.model.indexOf(check[0]);
                    if (check.length > 0) {
                        this.model[index].items.push({
                            label: "Package Overview Report",
                            icon: "content_copy",
                            routerLink: ["reports/package-overview-report"],
                        });
                    } else {
                        this.model.push({
                            label: "Reports",
                            icon: "insert_chart",
                            items: [
                                {
                                    label: "Package Overview Report",
                                    icon: "content_copy",
                                    routerLink: ["reports/package-overview-report"],
                                },
                            ],
                        });
                    }
                }
                if (permission.pageType === "Package Overview" && permission.pageName === "Package Overview Report") {
                    this.model.push({
                        label: "Package Overview Report",
                        icon: "hourglass_empty",
                        routerLink: ["/package-overview-report"],
                    });
                }
                if (
                    permission.pageType === "Services" &&
                    permission.pageName === "Services"
                ) {
                    const check = this.model.filter(
                        (x) => x.label === "Services"
                    );
                    const index = this.model.indexOf(check[0]);
                    if (check.length > 0) {
                        this.model[index].items.push({
                            label: "Services",
                            icon: "content_copy",
                            routerLink: ["/services"],
                        });
                    } else {
                        this.model.push({
                            label: "Services",
                            icon: "insert_chart",
                            items: [
                                {
                                    label: "Services",
                                    icon: "content_copy",
                                    routerLink: ["/services"],
                                },
                            ],
                        });
                    }
                }


                if (permission.pageType === "Analytics") {
                    this.model.push({
                        label: "Analytics",
                        icon: "hourglass_empty",
                        routerLink: ["/analytics"],
                    });
                }


                // if (permission.pageType === "Trainer Payout") {
                //     this.model.push({
                //         label: "Trainer Payout",
                //         icon: "insert_chart",
                //         routerLink: ["trainer/trainer-payout"],
                //     });
                // }




            });
        }
        this.model.push({
            label: "FAQs",
            icon: "group",
            url: "faq.html",
            target: "_blank",
        });
    }

    changeTheme(theme: string) {
        const themeLink: HTMLLinkElement = document.getElementById(
            "theme-css"
        ) as HTMLLinkElement;
        const layoutLink: HTMLLinkElement = document.getElementById(
            "layout-css"
        ) as HTMLLinkElement;

        themeLink.href = "assets/theme/theme-" + theme + ".css";
        layoutLink.href = "assets/layout/css/layout-" + theme + ".css";
    }
}

@Component({
    /* tslint:disable:component-selector */
    selector: "[app-submenu]",
    /* tslint:enable:component-selector */
    template: `
        <ng-template
            ngFor
            let-child
            let-i="index"
            [ngForOf]="root ? item : item.items"
        >
            <li
                [ngClass]="{ 'active-menuitem': isActive(i) }"
                [class]="child.badgeStyleClass"
                *ngIf="child.visible === false ? false : true"
            >
                <a
                    [href]="child.url || '#'"
                    (click)="itemClick($event, child, i)"
                    (mouseenter)="onMouseEnter(i)"
                    class="ripplelink"
                    *ngIf="!child.routerLink"
                    [attr.tabindex]="!visible ? '-1' : null"
                    [attr.target]="child.target"
                >
                    <i *ngIf="child.icon" class="material-icons">{{
                        child.icon
                    }}</i>
                    <span>{{ child.label }}</span>
                    <span class="menuitem-badge" *ngIf="child.badge">{{
                        child.badge
                    }}</span>
                    <i class="material-icons submenu-icon" *ngIf="child.items"
                        >keyboard_arrow_down</i
                    >
                </a>

                <a
                    (click)="itemClick($event, child, i)"
                    (mouseenter)="onMouseEnter(i)"
                    class="ripplelink"
                    *ngIf="child.routerLink"
                    [routerLink]="child.routerLink"
                    routerLinkActive="active-menuitem-routerlink"
                    [routerLinkActiveOptions]="{ exact: true }"
                    [attr.tabindex]="!visible ? '-1' : null"
                    [attr.target]="child.target"
                >
                    <i *ngIf="child.icon" class="material-icons">{{
                        child.icon
                    }}</i>
                    <span>{{ child.label }}</span>
                    <span class="menuitem-badge" *ngIf="child.badge">{{
                        child.badge
                    }}</span>
                    <i class="material-icons submenu-icon" *ngIf="child.items"
                        >keyboard_arrow_down</i
                    >
                </a>
                <div class="layout-menu-tooltip">
                    <div class="layout-menu-tooltip-arrow"></div>
                    <div class="layout-menu-tooltip-text">
                        {{ child.label }}
                    </div>
                </div>
                <ul
                    app-submenu
                    [item]="child"
                    *ngIf="child.items"
                    [visible]="isActive(i)"
                    [reset]="reset"
                    [parentActive]="isActive(i)"
                    [@children]="
                        (app.isSlim() || app.isHorizontal()) && root
                            ? isActive(i)
                                ? 'visible'
                                : 'hidden'
                            : isActive(i)
                            ? 'visibleAnimated'
                            : 'hiddenAnimated'
                    "
                ></ul>
            </li>
        </ng-template>
    `,
    animations: [
        trigger("children", [
            state(
                "hiddenAnimated",
                style({
                    height: "0px",
                })
            ),
            state(
                "visibleAnimated",
                style({
                    height: "*",
                })
            ),
            state(
                "visible",
                style({
                    height: "*",
                    "z-index": 100,
                })
            ),
            state(
                "hidden",
                style({
                    height: "0px",
                    "z-index": "*",
                })
            ),
            transition(
                "visibleAnimated => hiddenAnimated",
                animate("400ms cubic-bezier(0.86, 0, 0.07, 1)")
            ),
            transition(
                "hiddenAnimated => visibleAnimated",
                animate("400ms cubic-bezier(0.86, 0, 0.07, 1)")
            ),
        ]),
    ],
})
export class AppSubMenuComponent {
    @Input() item: MenuItem = {};

    @Input() root = false;

    @Input() visible = false;

    _reset = false;

    _parentActive = false;

    activeIndex: number | null = null;

    constructor(public app: SecureComponent) { }

    itemClick(event: Event, item: MenuItem, index: number) {
        if (this.root) {
            this.app.menuHoverActive = !this.app.menuHoverActive;
        }

        // avoid processing disabled items
        if (item.disabled) {
            event.preventDefault();
            return true;
        }

        // activate current item and deactivate active sibling if any
        this.activeIndex =
            this.activeIndex === index && this.root ? null : index;

        // execute command
        if (item.command) {
            item.command({ originalEvent: event, item });
        }

        // prevent hash change
        if (item.items || (!item.url && !item.routerLink)) {
            setTimeout(() => {
                this.app.layoutMenuScrollerViewChild.moveBar();
            }, 450);
            event.preventDefault();
        }

        // hide menu
        if (!item.items) {
            if (this.app.isHorizontal() || this.app.isSlim()) {
                this.app.resetMenu = true;
            } else {
                this.app.resetMenu = false;
            }

            this.app.overlayMenuActive = false;
            this.app.staticMenuMobileActive = false;
            this.app.menuHoverActive = !this.app.menuHoverActive;
        }
    }

    onMouseEnter(index: number) {
        if (
            this.root &&
            this.app.menuHoverActive &&
            (this.app.isHorizontal() || this.app.isSlim()) &&
            !this.app.isMobile() &&
            !this.app.isTablet()
        ) {
            this.activeIndex = index;
        }
    }

    isActive(index: number): boolean {
        return this.activeIndex === index;
    }
    @Input() get reset(): boolean {
        return this._reset;
    }

    set reset(val: boolean) {
        this._reset = val;

        if (this._reset && (this.app.isHorizontal() || this.app.isSlim())) {
            this.activeIndex = null;
        }
    }

    @Input() get parentActive(): boolean {
        return this._parentActive;
    }

    set parentActive(val: boolean) {
        this._parentActive = val;

        if (!this._parentActive) {
            this.activeIndex = null;
        }
    }
}
